import {
  DailyCheckinClaimError,
  classifyClaimError,
} from './daily-checkin-api';
import { mapClaimResult } from './daily-checkin.mappers';
import type { ApiPostDailyCheckinClaimPort } from '~/handlers/ports/api-post-daily-checkin-claim.port';
import type { DailyCheckinClaimResult } from '~/types/daily-checkin';
import { getApostatudoApiUrl } from '~/utils/apostatudo/get-apostatudo-api-url';
import { getApostatudoAuthHeaders } from '~/utils/apostatudo/get-apostatudo-auth-headers';

// POST /daily-check-in/claim — resgate do dia.
//
// NÃO recebe identificador de recompensa: o servidor decide qual degrau
// entregar (o menor ainda não resgatado). Mandar a posição daqui reabriria a
// corrida que as restrições de unicidade do core resolvem.
//
// A resposta traz SÓ o prêmio entregue — é o suficiente pro popup de vitória.
// Quem repõe o estado da trilha é o board, recarregado pela store logo depois.
//
// Limite do core: 10 req/min.
export class ApostatudoApiPostDailyCheckinClaimAdapter
  implements ApiPostDailyCheckinClaimPort
{
  async handle({
    userId,
  }: {
    userId: number;
  }): Promise<DailyCheckinClaimResult> {
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 10000);

    let response: Response;

    try {
      response = await fetch(`${getApostatudoApiUrl()}/daily-check-in/claim`, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          ...getApostatudoAuthHeaders(),
        },
        body: JSON.stringify({ user_id: userId }),
        signal: controller.signal,
      });
    } catch {
      // Timeout (AbortError) ou queda de rede (TypeError).
      throw new DailyCheckinClaimError('network');
    } finally {
      clearTimeout(timeoutId);
    }

    if (!response.ok) {
      // O corpo do erro é sempre { error, message } — `error` é o que decide o
      // caminho, `message` já vem em PT-BR e é repassada como fallback de copy.
      const err = await response.json().catch(() => ({}));

      throw new DailyCheckinClaimError(
        classifyClaimError(response.status, err?.error),
        err?.message,
      );
    }

    return mapClaimResult(await response.json());
  }
}
